export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_GDM_6.1f54ebf0.jpg";